export const USER_TYPES = {
    affiliate: {
        type: 1,
        name: 'Affiliate',
    },
    reseller: {
        type: 2,
        name: 'Reseller',
    },
}
